var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('vessel-monitoring-single-bay',{attrs:{"vesselBay":this.vesselHatch?.vesselBays[0]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }